import { Component, OnInit, ViewChild } from '@angular/core';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import * as uuid from 'uuid';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  db = firebase.firestore();
  storage = firebase.storage();
  currentUser = firebase.auth().currentUser;

  products = [];
  categories = [];
  categoryFocus = false;
  currentProduct: any = {
    name: '',
    category: '',
    description: '',
    price: '',
    active: true,
    dynamic: false,
    type: 'unique',
    items: []
  };
  image: any = {};
  types = [
    { value: 'unique', name: 'Único' },
    { value: 'uniqueWithChoices', name: 'Preço único com escolhas' },
    { value: 'sumPrices', name: 'Somar preços dos itens' },
    { value: 'moreExpensive', name: 'Preço do item de maior valor' },
    { value: 'multipleChoices', name: 'Múltiplas escolhas' },
  ];
  subTypes = [
    { value: 0, name: 'Selecione o tipo' },
    { value: 'sumPrices', name: 'Somar preços dos itens' },
    { value: 'uniqueWithChoices', name: 'Preço único com escolhas' },
  ];
  itemName;
  itemDescription;
  itemPrice;

  @ViewChild('newProductModal') newProductModal;

  faEdit = faEdit;
  faTrash = faTrash;

  constructor() {
    this.getProducts();
    this.getCategories();
  }

  ngOnInit() { }

  newProduct() {
    this.currentProduct = {
      name: '',
      category: '',
      description: '',
      price: '',
      active: true,
      type: 'unique',
      items: []
    };
    this.itemName = '';
    this.itemDescription = '';
    this.image = {};
    this.newProductModal.show();
  }

  addChoice() {
    this.currentProduct.choices ? this.currentProduct.choices.push({ id: uuid.v4(), type: 0 }) : this.currentProduct.choices = [{ id: uuid.v4(), type: 0 }];
  }

  addItem() {
    let item: any = { id: uuid.v4(), name: this.itemName, description: this.itemDescription };
    if (this.currentProduct.type == 'sumPrices' || this.currentProduct.type == 'moreExpensive') {
      if (!this.itemPrice) {
        return alert('Informe o preço');
      }
      item.price = this.itemPrice;
    }
    if (this.itemName.length < 2) {
      return alert('O Nome do item deve ter pelo menos 2 caracteres');
    }
    this.currentProduct.items.push(item);
    this.itemName = '';
    this.itemDescription = '';
    if (this.currentProduct.type == 'sumPrices' || this.currentProduct.type == 'moreExpensive') {
      this.itemPrice = null;
    }
  }

  addChoiceItem(choice) {
    if (choice.type == 0 || !choice.itemName || choice.itemName.length < 2) return alert('Preencha corretamente');
    if (choice.type == 'sumPrices' && !choice.itemPrice) return alert('Informe o preço');
    let item: any = { id: uuid.v4(), name: choice.itemName, description: choice.itemDescription || '' };
    if (choice.type == 'sumPrices') item.price = choice.itemPrice;
    delete choice.itemName;
    delete choice.itemDescription;
    delete choice.itemPrice;
    choice.items && choice.items.length > 0 ? choice.items.push(item) : choice.items = [item];
  }

  removeItem(id) {
    this.currentProduct.items = this.currentProduct.items.filter(i => { return i.id != id });
  }

  removeChoice(product, choice) {
    product.choices = product.choices.filter(i => { return i.id != choice.id });
  }

  removeChoiceItem(choice, id) {
    choice.items = choice.items.filter(i => { return i.id != id });
  }

  editProduct(product) {
    this.currentProduct = JSON.parse(JSON.stringify(product));
    console.log(this.currentProduct);
    
    this.image = {
      preview: this.currentProduct.image_url,
      change: false,
    };
    this.newProductModal.show();
  }

  getProducts() {
    this.products = [];
    this.db.collection('store').doc(this.currentUser.uid).collection('products').get().then(querySnapshot => {
      querySnapshot.forEach((doc) => {
        this.products.push({
          id: doc.id,
          name: doc.data().name,
          category: doc.data().category,
          type: doc.data().type,
          max: doc.data().max,
          min: doc.data().min,
          items: doc.data().items,
          choices: doc.data().choices,
          description: doc.data().description,
          price: doc.data().price,
          active: doc.data().active,
          image_url: doc.data().image_url ? doc.data().image_url : 'https://cdn.pixabay.com/photo/2014/04/02/10/48/food-304597_960_720.png'
        });
      });
    }, e => {
      console.log(e);
    });
  }

  getCategories() {
    this.db.collection('categories').get().then(querySnapshot => {
      querySnapshot.forEach((doc) => {
        this.categories.push(doc.data().name);
      });
    });
  }

  save() {
    if (this.currentProduct.type == 'multipleChoices') {
      if (!this.currentProduct.choices || this.currentProduct.choices.length < 1) return alert('O produto deve ter pelo menos 1 escolha');
      if (this.currentProduct.choices.filter(choice => !choice.items || choice.items.length == 0).length > 0) return alert('Todas as escolhas devem ter pelo menos 1 item');
      if (this.currentProduct.choices.filter(choice => choice.type == 'uniqueWithChoices' && (choice.min === null || choice.min === undefined || choice.max === null || choice.max === undefined || choice.max < 1 || choice.price < 0)).length > 0) return alert('Preencha corretamente');
    }
    if (this.currentProduct.name.length < 2) {
      return alert('O Nome do Produto deve ter pelo menos 2 caracteres');
    }
    if (this.currentProduct.category.length < 2) {
      return alert('Informe uma categoria');
    }
    if (this.currentProduct.type == 'unique') {
      if (this.currentProduct.price <= 0) {
        return alert('Informe um preço válido');
      }
    }
    if (this.currentProduct.type == 'uniqueWithChoices' || this.currentProduct.type == 'sumPrices' || this.currentProduct.type == 'moreExpensive') {
      if (this.currentProduct.type == 'uniqueWithChoices' && this.itemPrice <= 0) {
        return alert('Informe um preço válido');
      }
      if (this.currentProduct.type == 'sumPrices') {
        this.currentProduct.min = 1;
        this.currentProduct.max = 1;
      }
      if (this.currentProduct.min < 1) {
        return alert('O usuário deve ter pelo menos 1 escolha');
      }
      if (!this.currentProduct.max) {
        return alert('Informe o número máximo de escolhas');
      }
      if (this.currentProduct.items.length < 1 || this.currentProduct.items.length < this.currentProduct.min) {
        return alert('Informe uma quantidade de produtos adequada e de acordo com o mínimo de escolhas')
      }
    }
    if (this.currentProduct.type == 'sumPrices' || this.currentProduct.type == 'moreExpensive' || this.currentProduct.type == 'multipleChoices') {
      this.currentProduct.price = 0;
      this.currentProduct.description = '';
    }
    
    console.log(this.currentProduct);
    
    if (this.currentProduct.id) {
      this.db.collection('store').doc(this.currentUser.uid).collection('products').doc(this.currentProduct.id).set(this.currentProduct).then(() => {
        this.setCategory(this.currentProduct.category);
        if (this.image.change) {
          this.storage.ref().child(this.currentUser.uid).child(this.currentProduct.id + '.' + (this.image.type.split('/')[1] ? this.image.type.split('/')[1] : 'jpeg')).put(this.image.image).then(r => {
            r.ref.getDownloadURL().then(url => {
              this.db.collection('store').doc(this.currentUser.uid).collection('products').doc(this.currentProduct.id).update({ image_url: url }).then(() => {
                this.getProducts();
              });
            });
          });
        } else {
          this.getProducts();
        }
        this.newProductModal.hide();
      }, e => {
        alert(e);
      });
    } else {
      this.db.collection('store').doc(this.currentUser.uid).collection('products').add(this.currentProduct).then(createdProduct => {        
        this.setCategory(this.currentProduct.category);
        this.newProductModal.hide();
        if (this.image.change) {
          this.storage.ref().child(this.currentUser.uid).child(createdProduct.id + '.' + (this.image.type.split('/')[1] ? this.image.type.split('/')[1] : 'jpeg')).put(this.image.image).then(r => {
            r.ref.getDownloadURL().then(url => {
              this.db.collection('store').doc(this.currentUser.uid).collection('products').doc(createdProduct.id).update({ image_url: url }).then(() => {
                this.getProducts();
              });
            });
          });
        } else {
          this.getProducts();
        }
      }, e => {
        alert(e);
      });
    }
  }

  setCategory(category) {
    let categoriesArray = [];
    this.db.collection('store').doc(this.currentUser.uid).get().then(user => {
      if (user.data().categoriesArray && user.data().categoriesArray.length > 0) {
        categoriesArray = user.data().categoriesArray; 
      }
      if (!categoriesArray.includes(category)) {
        categoriesArray.push(category);
        this.db.collection('store').doc(this.currentUser.uid).update({
          categoriesArray
        });
      }
    });
  }

  selectImage(event, image) {
    if (!event.target || event.target.files.length < 1) {
      return;
    }

    let fileReader = new FileReader();
    const [file] = event.target.files;
    image.type = file.type.split('/')[1];
    image.filetype = file.type;
    
    fileReader.readAsArrayBuffer(file);

    fileReader.onload = (file: any) => {      
      image.preview = 'data:' + image.filetype + ';base64,' + this.encode(new Uint8Array(file.target.result));
      image.image =  new Uint8Array(file.target.result);
      image.change = true;
    }
  }

  onChangeActive(id, status) {
    this.db.collection('store').doc(this.currentUser.uid).collection('products').doc(id).update({
      active: status
    }).then(() => {
      this.getProducts();
    }, e => {
      console.log(e);
    });
  }

  deleteProduct(p) {
    this.db.collection('store').doc(this.currentUser.uid).collection('products').doc(p.id).delete().then(() => {
      this.getProducts();
    }, e => {
      console.log(e);
    });
  }

  categoryFocusEvent(focus) {
    setTimeout(() => {
      this.categoryFocus = focus;
    }, 200);
  }

  categoryChoose(category) {
    this.currentProduct.category = category;
  }

  encode (input) {
    let keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    let output = "";
    let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    let i = 0;

    while (i < input.length) {
        chr1 = input[i++];
        chr2 = i < input.length ? input[i++] : Number.NaN;
        chr3 = i < input.length ? input[i++] : Number.NaN;

        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;

        if (isNaN(chr2)) {
            enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
            enc4 = 64;
        }
        output += keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
    }
    return output;
  }

}
